import usePrivateAxios from '@/common/api/usePrivateAxios';
import { ErrorResponse } from '@/common/types/errorResponse';
import { useMutation, UseMutationOptions } from '@tanstack/react-query';

interface UseDeleteDashboardProps {
  dashboardId: string | undefined;
  options?: Partial<Omit<UseMutationOptions<
    unknown,
    ErrorResponse
  >, 'mutationKey' | 'mutationFn'>>;
}

export const useDeleteDashboard = ({
  dashboardId,
  options,
}: UseDeleteDashboardProps) => {
  const privateAxios = usePrivateAxios();

  return useMutation({
    mutationKey: ['deleteDashboard', dashboardId],
    mutationFn: () => {
      return privateAxios.delete(`/dashboards/${dashboardId}`);
    },
    ...options,
  });
}
